/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["object-settings-drawer .button-with-image mat-icon{margin-top:8px;vertical-align:middle}"];
export { styles as styles };
